module.exports = __webpack_public_path__ + "static/media/bg.036c0ffa.png";